export const GET_OPERATORS = 'GET_OPERATORS';
